import {
  nextFriday,
  nextMonday,
  nextSaturday,
  nextSunday,
  nextThursday,
  nextTuesday,
  nextWednesday,
} from 'date-fns';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MonthlyRecurrenceConfigDay } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  Inject,
  LOCALE_ID,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe, DatePipeConfig } from '@angular/common';

@Pipe({ name: 'recurrenceScheduleDay', pure: false, standalone: true })
export class RecurrenceScheduleDayPipe implements PipeTransform {
  private static readonly map = {
    [MonthlyRecurrenceConfigDay.Day]: 'day',
    [MonthlyRecurrenceConfigDay.Weekday]: 'weekday',
    [MonthlyRecurrenceConfigDay.WeekendDay]: 'weekend-day',
    [MonthlyRecurrenceConfigDay.Monday]: nextMonday,
    [MonthlyRecurrenceConfigDay.Tuesday]: nextTuesday,
    [MonthlyRecurrenceConfigDay.Wednesday]: nextWednesday,
    [MonthlyRecurrenceConfigDay.Thursday]: nextThursday,
    [MonthlyRecurrenceConfigDay.Friday]: nextFriday,
    [MonthlyRecurrenceConfigDay.Saturday]: nextSaturday,
    [MonthlyRecurrenceConfigDay.Sunday]: nextSunday,
  };
  private readonly datePipe: DatePipe;
  private readonly recurrenceDayTypes = [ MonthlyRecurrenceConfigDay.Day, MonthlyRecurrenceConfigDay.Weekday, MonthlyRecurrenceConfigDay.WeekendDay ];
  private readonly translatePipe: TranslatePipe;

  public constructor(
  @Inject(LOCALE_ID) localeId: string,
    @Inject(DATE_PIPE_DEFAULT_OPTIONS) defaultOptions: DatePipeConfig,
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.datePipe = new DatePipe(localeId, undefined, defaultOptions);
    this.translatePipe = new TranslatePipe(translateService, changeDetectorRef);
  }

  public transform(value: MonthlyRecurrenceConfigDay | null | undefined, abbr = true): string | null {
    if (value && this.recurrenceDayTypes.includes(value)) return this.translatePipe.transform(
      value ? `iss-wo-common.recurrence-schedule.monthly-day-type.${ RecurrenceScheduleDayPipe.map[value].toString() }` : '',
    ) as string;

    const nextWeekday = value ? RecurrenceScheduleDayPipe.map[value] : null;
    return nextWeekday && nextWeekday instanceof Function
      ? this.datePipe.transform(nextWeekday(new Date()), abbr ? 'EEE' : 'EEEE')
      : null;
  }
}
